import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import {
    Table,
    Button,
    Modal,
    message,
    Icon,
    Divider,
    Form,
    Input,
    Checkbox,
    TimePicker,
    InputNumber,
    DatePicker,
    Spin,
    TreeSelect
} from 'antd';
import attendanceRecordService from '../../services/Attendance/attendance-record-service';
import { fetchDepartmentsList } from '../../actions/department-structure-actions';
import resumeLibraryServcie from '../../services/Recruitment/resume-library-service';
class AttendanceNoCheckInOutRecord extends React.Component {

    state = {
        currentModalStatus: false,
        currentData: {
            data: [],
            detailData: [],
            total: 0,
            Total: 0
        },
        filter: {
            page: 1,
            pageSize: 20,
            search: ''
        }
    }

    componentWillMount() {
        this.fetchAttendanceNoCheckInOutRecordList({ page: 1 });
        this.props.fetchDepartmentsList();
    }

    //table列
    Column = [
        { title: "月份", key: "year_month", dataIndex: "year_month", className: 'table-global-head' },
        { title: "工号", key: "job_number", dataIndex: "job_number", className: 'table-global-head' },
        { title: "中文名", key: "real_name", dataIndex: "real_name", className: 'table-global-head' },
        { title: "英文名", key: "english_name", dataIndex: "english_name", className: 'table-global-head' },
        { title: "部门", key: "department_name", dataIndex: "department_name", className: 'table-global-head' },
        { title: "未打卡次数", key: "no_clockin_count", dataIndex: "no_clockin_count", className: 'table-global-head-short' },
        {
            title: "操作", key: "action", dataIndex: "action", className: 'table-global-head', render: (text, record, index) =>
                <Button icon="edit" size="small" className="row-action-btn" onClick={this.viewDetail.bind(this, record.employee_id, record.dateStr)}>查看</Button>
        }
    ]
    detailColumn = [
        { title: "月份", key: "year_month", dataIndex: "year_month", className: 'table-global-head' },
        { title: "工号", key: "job_number", dataIndex: "job_number", className: 'table-global-head' },
        { title: "日期", key: "date", dataIndex: "date", className: 'table-global-head' },
    ];
    //获取列表数据
    fetchAttendanceNoCheckInOutRecordList = (gets = this.state.filter) => {
        attendanceRecordService.selectAttendanceNoCheckInOutRecord(gets, res => {
            this.setState({ currentData: { ...this.state.currentData, data: res.data.Object.Data, Total: res.data.Object.Total } });
        })
    }
    //查看详情
    viewDetail = (employee_id, date) => {
        this.setState({ currentModalStatus: true });
        var gets = { employee_id, date };
        attendanceRecordService.selectAttendanceNoCheckInOutRecordDetail(gets, res => {
            if(res.data.Success){
                this.setState({ currentData: { ...this.state.currentData, detailData: res.data.Object } });
            }else{
                message.error(res.data.Errors[0]);
            }
        })
    }

    //关闭弹窗
    closeCurrentModal = () => {
        this.setState({ currentModalStatus: false });
    }

    //日期更改
    setDate = value => {
        if (value) {
            this.setState({ filter: { ...this.state.filter, date_time: value.format('YYYY-MM-DD'), page: 1 } });
            this.fetchAttendanceNoCheckInOutRecordList({ ...this.state.filter, date_time: value.format('YYYY-MM-DD'), page: 1 });
        } else {
            this.setState({ filter: { ...this.state.filter, date_time: null } });
            this.fetchAttendanceNoCheckInOutRecordList({ ...this.state.filter, date_time: null });
        }
    }
    //工号或者姓名查询
    setEmployeeFilter = value => {
        this.setState({ filter: { ...this.state.filter, search: value, page: 1 } });
        this.fetchAttendanceNoCheckInOutRecordList({ ...this.state.filter, search: value, page: 1 });
    }
    //部门变动
    setDepartmentFilter = (name, values, event) => {
        const department_id = event.triggerNode ? event.triggerNode.props.dataRef.id : ""
        this.setState({
            filters: {
                ...this.state.filters,
                department_id: department_id,
                page: 1
            }
        })
        this.fetchAttendanceNoCheckInOutRecordList({ ...this.state.filter, department_id: department_id, page: 1 });
    }
    //换页
    setPageFilter = pagination => this.setState({
        filters: {
            ...this.state.filters,
            page: pagination.current
        }
    }, this.fetchAttendanceNoCheckInOutRecordList({ ...this.state.filter, page: pagination.current }));
    //加载树节点
    renderTreeNodes = data => data.map(item => {
        if (item.children) {
            return (
                <TreeSelect.TreeNode title={item.name}
                    value={item.id + ""}
                    key={item.id}
                    dataRef={item}>
                    {item.children.length !== 0 && this.renderTreeNodes(item.children)}
                </TreeSelect.TreeNode>
            );
        }
        return <TreeSelect.TreeNode {...item} />
    })
    render() {
        return (
            <div className="app-module-item">
                <Modal width="800px"
                    visible={this.state.currentModalStatus}
                    destroyOnClose={true}
                    onCancel={this.closeCurrentModal.bind(this)}
                    footer={<Button type="back" onClick={this.closeCurrentModal.bind(this)}>关闭</Button>}>
                    <div style={{ textAlign: "center", margin: "20px 0px 20px" }}>
                        <Table columns={this.detailColumn} 
                        pagination={false} 
                        dataSource={this.state.currentData.detailData}
                        rowKey={(record, index) => index} />
                    </div>
                </Modal>
                <div className="colAction">
                    <span style={{ marginRight: "5px" }}>查询时间 : </span>
                    <DatePicker onChange={this.setDate} style={{ width: 120 }} />
                    <Divider type="vertical" />
                    <Input.Search
                        placeholder="报告人 工号/姓名"
                        onSearch={this.setEmployeeFilter}
                        style={{ width: 180 }}
                        defaultValue={null}
                        enterButton />
                    <Divider type="vertical" />
                    <span style={{ marginRight: "5px" }}>部门 : </span>
                    <TreeSelect style={{ minWidth: "300px", margin: '0px 5px 10px 0px' }}
                        allowClear
                        placeholder="请选择部门"
                        showSearch
                        autoExpandParent={true}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        treeDefaultExpandAll
                        onChange={this.setDepartmentFilter}>
                        {this.props.departmentStructure.departmentsList
                            && this.renderTreeNodes(this.props.departmentStructure.departmentsList)}
                    </TreeSelect>
                </div>
                <Table columns={this.Column} dataSource={this.state.currentData.data}
                    rowKey={(record, index) => index}
                    pagination={{
                        total: this.state.currentData.Total,
                        pageSize: this.state.filter.pageSize,
                        current: this.state.filter.page
                    }}
                    onChange={this.setPageFilter.bind(this)}
                />
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        departmentStructure: state.departmentStructure,
    }
}
const mapDispatchToProps = {
    fetchDepartmentsList,
}
AttendanceNoCheckInOutRecord = Form.create()(AttendanceNoCheckInOutRecord);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(AttendanceNoCheckInOutRecord));


// WEBPACK FOOTER //
// ./src/routes/Attendance/AttendanceNoCheckInOutRecord.js